import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import '../assets/styles/NavBar.css';
import favicon from '../assets/images/favicon.jpg';
import MobileNavDrawer from './MobileNavDrawer';

const NavBar = ({ onSectionClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [menuOpen, setMenuOpen] = useState(false);

  const goToSection = (sectionId) => {
    if (isHomePage) {
      onSectionClick(sectionId);
    } else {
      // If not on home page, navigate to home page first and then scroll
      window.location.href = `/#${sectionId}`;
    }
  };

  const handleClick = (e, sectionId) => {
    e.preventDefault();
    goToSection(sectionId);
  };

  const mobileNavItems = [
    { label: 'Blog', onClick: () => navigate('/Blogs'), selected: location.pathname === '/Blogs' },
    { label: 'Social Media', onClick: () => goToSection('social-media') },
    { label: 'Contact', onClick: () => navigate('/contact'), selected: location.pathname === '/contact' },
    { label: 'About', onClick: () => goToSection('about') },
    { label: 'Login', onClick: () => navigate('/Login'), selected: location.pathname === '/Login' }
  ];

  return (
    <nav className="navbar">
      <button
        className="ft-hamburger-btn ft-hamburger-btn--public"
        onClick={() => setMenuOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={24} />
      </button>
      <Link to="/" className="navbar-link brand-name">
        <img src={favicon} alt="Finn Tech" className="navbar-logo" />
      </Link>
      <Link to="/Blogs" className="navbar-link">Blog</Link>
      <a href="#social-media" className="navbar-link" onClick={(e) => handleClick(e, 'social-media')}>Social Media</a>
      <Link to="/contact" className="navbar-link">Contact</Link>
      <a href="#about" className="navbar-link" onClick={(e) => handleClick(e, 'about')}>About</a>
      <Link to="/Login" className="navbar-link login">Login</Link>
      <MobileNavDrawer
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        items={mobileNavItems}
        variant="public"
      />
    </nav>
  );
};

export default NavBar;
